import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import firebase from 'firebase';
import initializeFirebase from "./lib/firebase/initializeFirebase";
import {FirebaseProvider} from "./lib/firebase/FirebaseProvider";
import connectFirebase from "./lib/firebase/connectFirebase";
import {FirestorePersistGate} from "./lib/firebase/FirestorePersistGate";
import {ConnectedAuth} from "./auth/components/Auth";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {ConnectedChatClient} from "./client/ChatClient";
import {ChatRoomRouteComponent} from "./chat/ChatRoom";
import {Main} from "./chat/Main";
import {Container} from "./styled/container";


initializeFirebase({
  apiKey: "AIzaSyA5Uxam0E-PXkGsX-SDsPXFx5GvONpqBoM",
  authDomain: "bepro-chat-inquiry.firebaseapp.com",
  databaseURL: "https://bepro-chat-inquiry.firebaseio.com",
  projectId: "bepro-chat-inquiry",
  storageBucket: "bepro-chat-inquiry.appspot.com",
  messagingSenderId: "670457939675"
});

class App extends Component {
  render() {
    const {authorized} = this.props;
    return (
      <Container>
        {authorized ? <Router>
          <Container>
            <Route exact path="/" component={Main} />
            <Route path="/chat/:userId" component={ChatRoomRouteComponent} />
            <Route path="/client" component={ConnectedChatClient} />
          </Container>
        </Router> : <ConnectedAuth />}
      </Container>
    );
  }
}

const ConnectedApp = connectFirebase(null, ({locals}) => {
  return {authorized: locals.authorized};
})(App);

export default () => <FirebaseProvider firebase={firebase}>
    <ConnectedApp />
  </FirebaseProvider>;

